import { render, staticRenderFns } from "./TemplateDetailNormal2.vue?vue&type=template&id=c5a9a3c0&scoped=true&"
import script from "./TemplateDetailNormal2.vue?vue&type=script&lang=js&"
export * from "./TemplateDetailNormal2.vue?vue&type=script&lang=js&"
import style0 from "./TemplateDetailNormal2.vue?vue&type=style&index=0&id=c5a9a3c0&scoped=true&lang=css&"
import style1 from "./TemplateDetailNormal2.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5a9a3c0",
  null
  
)

export default component.exports